import { v1ApiClient } from '@/services';
import type { FeedbackListItemWithBlock } from '@/types/feedback';

export type RetrieveStudioItemFeedbacksParams = {
  category_id: number;
  offset: number;
  limit?: number;
  sortStatus?: SortStatusT;
  isPublic?: boolean;
};

export const retrieveStudioItemFeedbacks = async (
  itemId: Alias,
  params: RetrieveStudioItemFeedbacksParams,
): Promise<{
  items: FeedbackListItemWithBlock[];
  total_count: number;
}> => {
  const { sortStatus, offset, limit = 50, category_id, isPublic } = params;
  const response = await v1ApiClient.get(
    `/hey-syncly/studio/items/${itemId}/feedbacks${isPublic ? '/public' : ''}`,
    {
      params: {
        sortby: sortStatus?.sortBy || 'date',
        order: sortStatus?.orderStatus || 'desc',
        offset,
        limit,
        category_id,
      },
    },
  );

  return response.data;
};
